import { UserResponseDtoRoleEnum } from '@app/api';
import { SignUpStepsLabels } from '@app/types';
import dynamic from 'next/dynamic';
import { EnterEmail, EnterPhone, EnterPhoneModal } from './ChooseWay';
import ChooseWay from './ChooseWay/ChooseWay';
const CheckCode = dynamic(import('./CheckCode'));
const CreatePassword = dynamic(import('./CreatePassword'));

export const signUpSteps = (role: UserResponseDtoRoleEnum) => [
  {
    label: SignUpStepsLabels.chooseWay,
    component: <ChooseWay role={role} />,
  },
  {
    label: SignUpStepsLabels.enterPhone,
    component: <EnterPhone role={role} />,
  },
  {
    label: SignUpStepsLabels.enterEmail,
    component: <EnterEmail role={role} />,
  },
  {
    label: SignUpStepsLabels.checkPhone,
    component: <CheckCode />,
  },
  {
    label: SignUpStepsLabels.createPassword,
    component: <CreatePassword />,
  },
];

export const signUpStepsModal = (role: UserResponseDtoRoleEnum) => [
  {
    label: SignUpStepsLabels.enterPhone,
    component: <EnterPhoneModal role={role} />,
  },
  {
    label: SignUpStepsLabels.enterEmail,
    component: <EnterEmail role={role} />,
  },
  {
    label: SignUpStepsLabels.checkPhone,
    component: <CheckCode />,
  },
  {
    label: SignUpStepsLabels.createPassword,
    component: <CreatePassword />,
  },
];
